/**
 * @function shuffle
 * @description Shuffle the deck
 * @url https://vanillajstoolkit.com/helpers/shuffle/
 * @param {Array} array the array to be shuffled
 */
export default function shuffle(array) {
    let currentIndex = array.length,
        temporaryValue,
        randomIndex;
    while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
}
